export default "/images/vendor/flag-icons/flags/1x1/vg.svg?fe6ff226f91c90e6e2d6a59a24fe50b2";